import React, { useState,useEffect } from "react";
import api from "views/auth/Api";
import "../../myProjects/Myprojects.css"
import {columnsDataComplex} from "../../tables/variables/columnsData";
import ModelsTable from "../../tables/components/ModelsTable";
import { TbFile3D } from "react-icons/tb";
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import { FiEdit } from "react-icons/fi";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";




const ModelPrint = () => {

      const [data , setData] = useState([]); 
      const [tableData , setTableData] = useState([]); 
      // const [imgs, setImgs] = useState([]);
      const [selected, setSelected] = useState(null);

        const token = localStorage.getItem('token');
        const decoded = jwtDecode(token);
        const role = decoded.role; 

      const { id } = useParams();
      const navigate = useNavigate();    

     useEffect(() => {
     api.get(`${API_BASE_URL}projects-3dmodel/${id}`)
      .then((response) => {  
        if (!response.data) {
          navigate(`/auth/not-found/`);
        }
        setData(response.data);
        setTableData(response.data?.modelParts)
        // setImgs(response.data?.imgs)

      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });
  }, [navigate,id]);

  const selectPlate =(id)=>{
      setSelected(id);
        console.log("Selected Plate ID:", id);
      }


  return (
    <div>
        <div className="libraryHeader">
          <div className="libraryH">
          <h1>3D Models</h1>
{role === "Admin" ? <div className="flex gap-3">  <Link to={`/admin/tr/library/modeledit/${id}`}><div className="newChallenge">
                     <FiEdit className="addImg"/>
                     <span>Edit</span>
                    </div></Link>
{/* <div className="newChallenge">
                     <MdOutlineDeleteForever className="addImg" 
                    //  onClick={()=> {delModel(id)}}
                     />
                     <span>Delete</span>
                    </div> */}
                    </div> : null}          
                    </div>
          <div className="libraryheaderImg"></div>
        </div>
      <div className="model3d-container"> 
        <div className="model3d-cards" >
        {tableData.map(img =>
                            <div className={selected === img.id ? "model3d-cardSelected" : "model3d-card"} style={{backgroundImage:`url(${FILES_URL}${img.img?.url})`}}>
                              </div>
                        )}
        </div>
  <div className="table3D">
        <ModelsTable
          columnsData={columnsDataComplex}
          tableData={tableData}
          selectPlate ={selectPlate}
        />
     <div className="print3D"><TbFile3D className="printIcon"/><span>Print</span></div>
   </div>
   
        </div>
    </div>
  );
};

export default ModelPrint;
